module.exports = __webpack_public_path__ + "images/a69d6d1b5a1f1d58cd7c1168c0cf857a-IMG_6585.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/bedroom/IMG_6585.jpg
// module id = ./src/assets/images/slides/bedroom/IMG_6585.jpg
// module chunks = 0